<template>
  <div id="permit_content">
    <div v-for="trekker in trekkers" style="height: 100vh;">
      <div>
        <div>
          <img :src="logo" alt="logo" style="float: left;width: 10%">
          <span style="float:left;margin-left: 10px;">

                 <div style="font-size: 18pt;">
                     <b>
                                              Department of Immigration
                     </b>
                 </div>
                 <div>
                     Kalikasthan, Dillibazar, Kathmandu
                 </div>
                 <div>
                     +977-01-4429659, 4429660
                 </div>
                 <div>
                     <a href="mailto:info@immigration.gov.np" target="_top" style="margin-right: 10px;">info@immigration.gov.np</a> <a
                     href="mailto:info@immigration.gov.np" target="_top">info@immigration.gov.np</a>
                 </div>
             </span>
        </div>
        <div style="clear: both;"></div>
        <br>

        <div style="float: left;">
          In accordance with the rule 33 of Immigration Rules, <br>
          1994, the permission is hereby granted to and for:
        </div>
        <div style="float: right;">
          <img :src="trekker.photo" height="100" width="100">
        </div>

        <div style="clear: both"></div>

        <div class="m-t-20" style="margin-bottom: 20px;">
          <div style="font-size: 14pt;">Trekking Permit</div>
        </div>
        <table style="width: 100%;">
          <tbody>
          <tr>
            <td>Name:</td>
            <td class="font-bold">
              {{ trekker.name }}
            </td>
          </tr>
          <tr>
            <td>Nationality</td>
            <td class="font-bold">{{ trekker.country }}</td>
          </tr>
          <tr>
            <td>Passport Number</td>
            <td class="font-bold">{{ trekker.passport_number }}</td>
          </tr>
          <tr>
            <td>Trekking Route</td>
            <td class="font-bold">{{ trekkingRoute.name }}</td>
          </tr>
          <tr>
            <td>Trekking Agency</td>
            <td class="font-bold">{{ trekkingAgency.name }}</td>
          </tr>

          <tr >
            <td>Trekking permit no</td>
            <td class="font-bold">{{ trekker.permit_no }}</td>
          </tr>
          <tr v-if="parseInt(total_cost) !== 0 || trekker.isFree === 'false'">
            <td>Trekking sticker no</td>
            <td class="font-bold">{{ trekker.sticker_no ? trekker.sticker_no : trekker.sticker_serial_no}}</td>
          </tr>
          <tr>
            <td>Trekking Schedule</td>
            <td class="font-bold">{{ trekkingData.starting_date }} to {{ trekkingData.end_date }}</td>
          </tr>
          <tr>
            <td>Trekking Fee($)</td>
            <td class="font-bold">{{ (trekker.isFree === 'true' || (getAge(trekker.dob) < 10 && trekker.country != 'United States of America (USA)')) ? 0 : total_cost / (trekkers.length - freeTrekkers.length) }}</td>
          </tr>
          </tbody>
        </table>
        <div style="clear: both;"></div>
        <div style="float:right;margin-top: 70px;">
          <!--                  <div style="border: 1px solid black; height: 100px; width: 100px;"></div>-->
          <div>
            <div class="font-bold">{{ approvedUser ? approvedUser : user.user.full_name }}</div>
            <div>
              Immigration Trekking Officer
            </div>
            <div style="height: 20px; border-bottom: 1px dotted black;"></div>
          </div>
        </div>
        <div style="clear: both"></div>
      </div>
    </div>
  </div>

</template>

<script>
import {BASE_URL} from "../../../config/config";
import moment from "moment";

export default {
  name: "print",
  props: ['trekkers', 'trekkingData', 'trekkingAgency', 'total_cost', 'trekkingRoute', 'user'],
  data() {
    return {
      logo: BASE_URL + 'logo.png'
    }
  },
  computed: {
    approvedUser(){
      let approvedTracks = this.trekkingData.tracks.filter(item=>{
        return item.statusNumber === 35;
      })
      return approvedTracks[0].user.name;
    },
    freeTrekkers(){
      return this.trekkers.filter(item=>{
        return (item.isFree == 'true' || (this.getAge(item.dob) < 10 && item.country != 'United States of America (USA)'));
      })
    }
  },
  methods: {
    getAge(dob){
      return moment().diff(dob, 'years',false);
    },
    getLatestPassportNumber(documents) {
      if (typeof documents !== 'undefined') {
        let passport_documents = documents.filter((document) => document.document_type === 'passport');
        let latest_passport = passport_documents.pop();
        return latest_passport.document_number;
      }
    }
  },
  mounted() {
    console.log(this.trekkers);
  }
}
</script>

<style scoped>

table, th, td {
  border: 1px solid black;
}

table {
  border-collapse: separate;
  border-spacing: 1px;
  border-left: 0;
  border-bottom: 0;
}

td, th {
  border-top: 0;
  border-right: 0;
  padding: 5px;
}

.font-bold {
  font-weight: bold;
}
</style>
